import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {Col, Row, Button} from 'reactstrap';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { MagstimHeaderBar, CurrentTheme, MagstimColor, isPDA, CurrentLang  } from "common";

const grid = 8;

class CombinedTreatmentSummaryDroppable extends React.Component {
	render() {
		return (
			<Droppable droppableId="droppable">
				{(provided, snapshot) => (
					<div
						{...provided.droppableProps}
						ref={provided.innerRef}
						style={{
							background: snapshot.isDraggingOver ? MagstimColor.MagstimGroupBackground : MagstimColor.MagstimGroupBackground,
							padding: grid
						}}
					>
						{this.props.dataItems.map((dataItem, index) => (
							<CombinedTreatmentSummaryDraggable index={index} dataItem={dataItem} key={dataItem.id} />
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		);
	}
}

class CombinedTreatmentSummaryDraggable extends React.Component {
	render() {
		return (
			<Draggable key={this.props.dataItem.id} draggableId={this.props.dataItem.id} index={this.props.index}>
				{(provided, snapshot) => (
					<div
						key={this.props.dataItem.id}
						ref={provided.innerRef}
						{...provided.draggableProps}
						{...provided.dragHandleProps}
						style={{
							userSelect: "none",
							padding: grid * 2,
							margin: `0 0 ${grid}px 0`,
							background: snapshot.isDragging ? MagstimColor.MagstimTextBackground : MagstimColor.MagstimTextBackground,
							color: 'white',
							...provided.draggableProps.style
						}}
					>
						<div className="ui-drag">
							<Row>
								<Col lg="1"><i className="fas fa-grip-lines"></i></Col>
								<Col lg="10">{this.props.dataItem.content}</Col>
							</Row>
						</div>

					</div>
				)}
			</Draggable>
		);
	}
}
class CombinedTreatmentSummary extends React.Component {

	constructor(props) {
		super(props);

		this.onDragEnd = this.onDragEnd.bind(this);
		this._saveButton = React.createRef();
		this._deleteButton = React.createRef();

		this.state = {
			dragDropHeight: isPDA() ?  'calc(100vh - 360px)' : 'calc(100vh - 170px)',
			listitems: [],
			dataItems: [],
			saveDisabled: true
		};
	}

	// a little function to help us with reordering the result
	reorder = (list, startIndex, endIndex) => {
		const result = Array.from(list);
		const [removed] = result.splice(startIndex, 1);
		result.splice(endIndex, 0, removed);
		return result;
	};

	onDragEnd = (result) => {
		// dropped outside the list
		if (!result.destination) {
			return;
		}

		const items = this.reorder(
			this.state.listitems,
			result.source.index,
			result.destination.index
		);

		this.setSelectedTreatments(items);

		if(null !== this.props.setNonFormikInputsTouched && undefined !== this.props.setNonFormikInputsTouched){
			this.props.setNonFormikInputsTouched();
		}
	}

	render() {

		// console.log(`CombinedTreatmentSummary.render props=${JSON.stringify(this.props, null, 4)} state=${JSON.stringify(this.state, null, 4)} `);

		return (
			<Wrapper dragDropHeight={this.state.dragDropHeight}>
				<Col >
					<Row className="ui-header">
						<Col>
							<MagstimHeaderBar main_title={this.props.main_title} ShowClose={false} />
						</Col>
					</Row>

					<Row className="drag-drop-row ui-bg ui-scroll">
						<Col className="m-3 pt-3">
							<DragDropContext onDragEnd={this.onDragEnd}>
								<CombinedTreatmentSummaryDroppable dataItems={this.state.dataItems} />
							</DragDropContext>
						</Col>
					</Row>

					<Row>
						<Col className="m-4 ui-control-foot">
							<Button color="secondary" className="mr-3 mb-1" ref={this._deleteButton} onClick={this.props.onDelete} disabled={!this.props.deleteEnabled} size={CurrentTheme().ControlSize}><i className="fas fa-trash-alt"></i></Button>
							<Button color="primary" className="mr-3 mb-1" ref={this._saveButton} disabled={this.state.saveDisabled} onClick={this.props.onSave} size={CurrentTheme().ControlSize} >
								<i className="fas fa-save"></i> {this.props.isSubmitting ? CurrentLang().validation_please_wait : CurrentLang().validation_save}
							</Button>
						</Col>
					</Row>
				</Col>
			</Wrapper>
		);
	}

	componentDidMount() {
	}


	getSelectedTreatments() {

		//console.log('getSelectedTreatments', this.state.listitems);

		return this.state.listitems;
	}

	setSelectedTreatments(listitems) {

		//console.log('setSelectedTreatments', listitems);

		var dataItems = [];
		if ((undefined !== listitems) && (null != listitems)) {
			for (var index = 0; index < listitems.length; index++) {
				dataItems[index] = { id: listitems[index].ProtocolGuid, content: listitems[index].name };
			}
		}
		
		//console.log('setSelectedTreatments', dataItems);

		let isDisabled = true;
		let noName = this.props.name ==="";
		let isCombined = (dataItems.length>1);
		if (!noName && isCombined ) {
			isDisabled = false;
		}
		else {
			isDisabled = true;
		}
		
		this.setState({
			listitems: listitems, 
			dataItems: dataItems,
			saveDisabled: isDisabled,
			statusDisabled: isDisabled
		});
	}

	setSaveDisabled(isDisabled) {
		this.setState({
			saveDisabled: isDisabled
		});
	}
}

CombinedTreatmentSummary.propTypes = {
	main_title: PropTypes.string,
	name: PropTypes.string,
	onSave: PropTypes.func,
	onDelete: PropTypes.func,
	deleteEnabled: PropTypes.bool,
	dataItems: PropTypes.array,
	dataItem: PropTypes.object,
	index: PropTypes.number,
	isSubmitting: PropTypes.bool
};

CombinedTreatmentSummary.defaultProps = {
	main_title: 'Summary',
	name: '',
	onSave: undefined,
	onDelete: undefined,
	deleteEnabled: false,
	isSubmitting:false
};

const Wrapper = styled.aside`

.drag-drop-row {
    height: ${props => props.dragDropHeight};
    overflow: hidden;
	}

.ui-control-foot {
	.btn {
		box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
	}
	.btn-secondary {
		width: 90px;
	}
	.btn-primary {
		width: 160px;
	}
}

`;

export default CombinedTreatmentSummary;